 import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PosHttpService } from '../../services/pos.http.service';

@Injectable({
  providedIn: 'root'
})
export class JpqlService {
  requestMap={};
  constructor(
    private posHttpSvcs:PosHttpService,
    
  ) { }

  getQueryFromUser(query:string):Observable<any>{
    const xSignKey=query.slice(query.length-6);
    return this.posHttpSvcs.authPost('v1/jpql/sendQuery',xSignKey ,query); 
  }

  getQueryResultCount(query:string):Observable<any>{
    const xSignKey=query.slice(query.length-6);
    return this.posHttpSvcs.authPost('v1/jpql/jpqlRowCnt',xSignKey ,query); 
  }
  getQueryResultCountNative(query:string):Observable<any>{
    const xSignKey=query.slice(query.length-6);
    return this.posHttpSvcs.authPost('v1/jpql/jpqlRowCntNative',xSignKey ,query); 
  }

  getQueryFromUserNative(query:string):Observable<any>{
    const xSignKey=query.slice(query.length-6);
    return this.posHttpSvcs.authPost('v1/jpql/sendQueryNative',xSignKey ,query); 
  }

  clearCache() :Observable<any>{
    const xSignKey="clearCache";
    return this.posHttpSvcs.authDelete('v1/jpql/clear',xSignKey); 
  }

}
 
